import React from 'react';
import Markdown from 'markdown-to-jsx';
import { decodeDisplayText } from '../../util/displayText';
import { linkifyMarkdownTitle } from '../../util/titleText';
import { createMarkdownToJsxOptions, normalizeMarkdownForStorage } from '../../util/markdownTheme';

// Use the same normalizer, link tokenizer and markdown theme as DefaultMessage.
// A public message has no task mutations or private-message navigation handlers.
export default function ReadOnlyMessageText({ text }) {
    const options = React.useMemo(() => {
        const base = createMarkdownToJsxOptions({
            surface: 'dark',
            linkColor: '#5ca2ff',
            textColor: 'inherit',
            bodyFontSizePx: 14
        });
        return { ...base, forceBlock: true, overrides: { ...base.overrides, a: { component: PublicTextLink } } };
    }, []);
    const markdown = linkifyMarkdownTitle(normalizeMarkdownForStorage(String(decodeDisplayText(text) || '')));
    return (
        <div
            onClick={event => {
                if (event.target.closest?.('a,button,input')) event.stopPropagation();
            }}
            onKeyDown={event => {
                if (event.target.closest?.('a,button,input')) event.stopPropagation();
            }}
        >
            <Markdown options={options}>{markdown}</Markdown>
        </div>
    );
}

function PublicTextLink({ href, children }) {
    // Internal message references must not expand through account-only queries.
    if (!/^https?:\/\//i.test(href || '') && !/^(mailto:|tel:)/i.test(href || '')) return <span>{children}</span>;
    return (
        <a
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: '#5ca2ff', textDecoration: 'underline' }}
        >
            {children}
        </a>
    );
}
